export default __webpack_public_path__ + "static/media/giraffe.49a2fdfd.svg";